import { Session } from "./types";
let csrfToken: string | null = null;
export async function api<T>(
  path: string,
  method = "GET",
  data?: unknown,
): Promise<T> {
  const headers: Record<string, string> = {};
  if (data !== undefined) headers["Content-Type"] = "application/json";
  if (method !== "GET" && csrfToken) headers["X-CSRF-Token"] = csrfToken;
  const response = await fetch("/api" + path, {
    method,
    credentials: "same-origin",
    headers,
    body: data === undefined ? undefined : JSON.stringify(data),
  });
  const value = await response.json();
  if (!response.ok) throw new Error(value.error || "Request failed.");
  return value;
}
export async function session() {
  const s = await api<Session>("/session");
  csrfToken = s.csrfToken;
  return s;
}
export async function login(username: string, password: string) {
  const s = await api<Session>("/login", "POST", { username, password });
  csrfToken = s.csrfToken;
  return s;
}
export async function logout() {
  await api("/logout", "POST", {});
  csrfToken = null;
}
export async function upload(file: File) {
  const response = await fetch("/api/admin/media", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": file.type, "X-CSRF-Token": csrfToken || "" },
    body: file,
  });
  const value = await response.json();
  if (!response.ok) throw new Error(value.error || "Upload failed.");
  return value as { url: string };
}
